import Cookies from 'js-cookie';
import { showError, useRuntimeConfig } from '#imports';
import { fatalErrorHandler } from './helpers';

function createApiFetchClient() {
  const config = useRuntimeConfig();
  const locale = Cookies.get('i18n_redirected');
  const token = Cookies.get('auth_token');

  return $fetch.create({
    baseURL: `${config.public.apiUrl}`,
    headers: {
      'Accept-Language': locale,
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    } as {
      'Accept-Language': string;
      Accept: string;
      Authorization: string;
    },
    onResponse({ response }) {
      fatalErrorHandler(response);
    },
  });
}

export async function apiFetch<T>(
  request: string,
  options?: Parameters<ReturnType<typeof createApiFetchClient>>[1]
) {
  const client = createApiFetchClient();
  return await client<T>(request, options);
}
